import { render, staticRenderFns } from "./MyBalance.vue?vue&type=template&id=961e4b48&scoped=true&"
import script from "./MyBalance.vue?vue&type=script&lang=js&"
export * from "./MyBalance.vue?vue&type=script&lang=js&"
import style0 from "./MyBalance.vue?vue&type=style&index=0&id=961e4b48&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961e4b48",
  null
  
)

export default component.exports